/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_LoggedInputs */

const en_history_logged = /** @type {(inputs: History_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logged`)
};

const de_history_logged = /** @type {(inputs: History_LoggedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingetragen`)
};

/**
* | output |
* | --- |
* | "Logged" |
*
* @param {History_LoggedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_logged = /** @type {((inputs?: History_LoggedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_LoggedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_logged(inputs)
	return en_history_logged(inputs)
});